module.exports = __webpack_public_path__ + "img/defaultAvatarMan.2a4da99a.svg";